import { ValidationContextName, ValidationWarning } from '@interfaces/connector';
import { FOLDER_NAME_PATH_SEPARATOR } from '@components/settings/v2/structure/connector/productionConnectorSetup/components/ValidationErrorsPopup/constants';

import { ParsedValidationWarningContext } from '@components/settings/v2/structure/connector/productionConnectorSetup/components/ValidationErrorsPopup/types';

export const parseValidationWarningContext = ({
  validationContextName,
  validationContextValue,
}: Pick<ValidationWarning, 'validationContextName' | 'validationContextValue'>): ParsedValidationWarningContext => {
  if (validationContextName === ValidationContextName.DOCUMENTS_ROOT_FOLDER) {
    return { folderName: '', folderPath: validationContextValue };
  }

  const separatorIndex = validationContextValue.indexOf(FOLDER_NAME_PATH_SEPARATOR);
  const separatorNotFound = separatorIndex === -1;
  const folderName = separatorNotFound ? '' : validationContextValue.slice(0, separatorIndex);

  return {
    folderName,
    folderPath: validationContextValue.slice(separatorIndex + 2).trim(),
  };
};
